import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { profile } from "../../data/profile";
import { motion } from "framer-motion";

export default function Contact() {
  return (
    <Container fluid className="contact-section" id="contact">
      <Container>
        <Row style={{ justifyContent: "center", paddingBottom: "30px" }}>
          <Col md={10} lg={8}>
            <motion.div
              className="contact-card"
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.35 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
            >
              <h2 className="contact-title">
                Let’s build something <span className="purple">scalable</span> together.
              </h2>
              <p className="contact-subtitle">
                {profile.availability.headline}
                <br />
                {profile.availability.subline}
              </p>

              <div className="contact-links">
                <a className="contact-link" href={`mailto:${profile.contact.email}`}>
                  {profile.contact.email}
                </a>
                <span className="contact-dot">·</span>
                <a className="contact-link" href={`tel:${profile.contact.phone}`}>
                  {profile.contact.phone}
                </a>
              </div>

              <div className="contact-social">
                <a
                  href={profile.contact.github}
                  target="_blank"
                  rel="noreferrer"
                  className="contact-social-icon"
                  aria-label="GitHub"
                >
                  <AiFillGithub />
                </a>
                <a
                  href={profile.contact.linkedin}
                  target="_blank"
                  rel="noreferrer"
                  className="contact-social-icon"
                  aria-label="LinkedIn"
                >
                  <FaLinkedinIn />
                </a>
              </div>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

